import React, { useEffect, useState } from "react";
import { useT } from "@/i18n/i18n";
import api from "@/lib/api";
import { PageTitle, Panel } from "@/pages/app/kit";
import { Printer } from "lucide-react";
import { Btn } from "@/pages/app/kit";

export default function InvestorRoomPage() {
  const { t, lang } = useT();
  const L = (pl, en) => (lang === "pl" ? pl : en);
  const [content, setContent] = useState(null);
  const [risks, setRisks] = useState([]);

  useEffect(() => {
    api.get("/settings/public").then((r) => setContent(r.data.investor_content)).catch(() => {});
    api.get("/admin/risks").then((r) => setRisks(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <PageTitle title={t("dashboard.investor")} subtitle={L("Sala danych dla inwestorów","Investor data room")}
        action={<Btn variant="outline" icon={Printer} onClick={() => window.print()}>{L("Drukuj","Print")}</Btn>} />
      <div className="space-y-4">
        {(content?.sections || []).map((s) => (
          <Panel key={s.key} title={s.title}><p className="text-sm leading-relaxed text-mutedtext">{s.body}</p></Panel>
        ))}
        {content?.use_of_funds && (
          <Panel title={L("Wykorzystanie środków (ilustracyjne)","Use of funds (illustrative)")}>
            <div className="space-y-3">
              {content.use_of_funds.map((u) => (
                <div key={u.label}>
                  <div className="flex justify-between text-sm"><span>{u.label}</span><span className="font-semibold">{u.pct}%</span></div>
                  <div className="mt-1 h-2 rounded-full bg-secondary"><div className="h-2 rounded-full bg-forest" style={{ width: `${u.pct}%` }} /></div>
                </div>
              ))}
            </div>
          </Panel>
        )}
        <Panel title={L("Rejestr ryzyka","Risk register")}>
          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px] text-sm" data-testid="risk-table">
              <thead><tr className="border-b border-subtle text-left text-mutedtext"><th className="py-1">Risk</th><th>Probability</th><th>Impact</th><th>Mitigation</th><th>Owner</th></tr></thead>
              <tbody>
                {risks.map((r) => (<tr key={r.id} className="border-b border-subtle last:border-0"><td className="py-1.5 font-medium">{r.title}</td><td>{r.probability}</td><td>{r.impact}</td><td className="text-mutedtext">{r.mitigation}</td><td>{r.owner}</td></tr>))}
              </tbody>
            </table>
          </div>
        </Panel>
      </div>
    </div>
  );
}
